<template>
  <div class='Radio'>
    <el-radio-group v-model.trim="formInline.value" :disabled='!formInline.compile' @change="change">
      <el-radio v-for="(item, index) in formInline.optionList" :key="index" :label="item.label">{{item.label}}</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
import deepClone from '@/shared/utils/deep-clone'
export default {
  name: 'Radio',

  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {
      formInline: { value: '' }
    }
  },

  watch: {
    data (val) {
      this.formInline = deepClone(this.data).controls
    }
  },

  mounted () {
    this.formInline = deepClone(this.data).controls
  },

  methods: {
    change () {
      const obj = deepClone(this.data)
      obj.controls = this.formInline
      this.$emit('changeControls', obj)
    }
  }
}
</script>
